import * as PIXI from "pixi.js";
import data from "../configs/data";
import {PixiApplication} from "../PixiApplication";

export class ProgressBar extends PIXI.Container {

    private activeBackgroundMask: PIXI.Graphics;
    private activeBackground: PIXI.Sprite;

    constructor() {
        super();
        this.createProgressBarBackground();
        this.createMaskSliderActiveBackgroundMask();
    }

    public updateValue(progressInPercents: number): void {
        this.activeBackgroundMask.width = this.activeBackground.width;
        this.activeBackgroundMask.position.x = -this.activeBackground.width +
            progressInPercents / 100 * this.activeBackground.width;
    }

    private createMaskSliderActiveBackgroundMask(): void {
        this.activeBackground = PIXI.Sprite.fromImage(data.loadingScreen.images.loadingBarCover);
        const activeBackgroundContainer = new PIXI.Container();
        activeBackgroundContainer.addChild(this.activeBackground);

        this.activeBackgroundMask = new PIXI.Graphics();
        this.activeBackgroundMask.beginFill(0xFFFFFF);
        this.activeBackgroundMask.drawRect(0, 0, PixiApplication.WIDTH, 200);
        this.activeBackgroundMask.position.x = 1200;
        this.activeBackgroundMask.endFill();
        activeBackgroundContainer.mask = this.activeBackgroundMask;
        activeBackgroundContainer.addChild(this.activeBackgroundMask);
        this.addChild(activeBackgroundContainer);
    }

    private createProgressBarBackground(): void {
        const background = PIXI.Sprite.fromImage(data.loadingScreen.images.loadingBarBack);
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/loadingScreen/ProgressBar.ts